import _ from "lodash";
import React, {Component} from "react";
import {connect} from 'react-redux';
import {withRouter} from "react-router-dom";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import sharePollStyle from "assets/jss/material-kit-react/views/pollTemplateSections/sharePollStyle.jsx";
import {socialButtons} from "./socialIconsHelper";

class ShareSection extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // NOTE this resets the links inside the addthis share buttons
    // each time the poll changes. this was a bitch to figure out... bad docs
    if (window.addthis) {
      if (typeof window.addthis.layers.refresh !== 'undefined') {
        window.addthis.layers.refresh();
      }
    }
  }

  renderShareButtons() {
    const {classes, poll} = this.props;

    if (this.props.addThisLoaded === true) {
      const this_url = `http://www.pollpals.com/poll/${poll.data.poll_hash}`;
      const descrip = _.isEmpty(poll.data.pollmeta) ? '' : poll.data.pollmeta.descrip;

      return (
        <div id="addthisdiv" className={classes.socialIconContainer}>
          <div
            className="addthis_inline_share_toolbox"
            data-url={this_url}
            data-title={poll.data.question}
            data-description={descrip}
            data-image={poll.data.img}
          />
        </div>
      );
    } else {
      // console.log('cannot add this');
    }
  }

  render() {
    const {classes} = this.props;

    return (
      // <div className={classes.section}>
      <div>
        {/* <GridContainer justify="flex-start"> */}
          <GridItem xs={12} sm={12} md={12}>
            {/* <h2 className={classes.title}>share</h2> */}
            {this.renderShareButtons()}
          </GridItem>
        {/* </GridContainer> */}
      </div>
    );
  }
}

const pageWithStyles = withStyles(sharePollStyle)(ShareSection);

function  mapStateToProps(state) {
  return {
    poll: state.poll,
  }
}

export default withRouter(connect(mapStateToProps)(pageWithStyles));



// WEBPACK FOOTER //
// ./src/views/PollTemplate/ShareSection.js